import { TWO_FA_METHOD } from '@/screens/TrustedDevice/2FA/constants';

const isTrue = (v) => v === 'true';
const isFalse = (v) => v === 'false';

const PRE_PIN_ROUTES = [
  '/pin',
  '/2fa',
  '/create-pin',
  '/validate-pin',
  '/renew-pin',
  '/suspended',
  '/loading',
];

export const NavigationService = {
  isPrePinRoute: (pathname) => PRE_PIN_ROUTES.some((route) => pathname === route),

  handleNavigation: (
    isTrustedDevice,
    haveTrustedDevice,
    isDeviceSuspended,
    hasSetPin,
    pinNeedChange,
    isPin6Digit,
    accessToken,
    location,
    navigate
  ) => {
    const { pathname } = location;

    const navigationRules = [
      // CASE 1 – Suspended device
      {
        condition: isTrue(isDeviceSuspended),
        action: () => {
          // console.log('CASE 1 – Suspended device');
          if (pathname !== '/suspended') navigate('/suspended');
        },
      },
      // CASE 2 – User hasn't set PIN yet
      {
        condition: accessToken === undefined && isFalse(hasSetPin),
        action: () => {
          // console.log('CASE 2 – User hasnt set PIN yet');
          if (!['/create-pin', '/validate-pin'].includes(pathname)) navigate('/create-pin');
        },
      },
      // CASE 3 – Trusted device flow (PIN validation)
      {
        condition:
          accessToken === undefined &&
          isTrue(isTrustedDevice) &&
          (isFalse(haveTrustedDevice) || isTrue(haveTrustedDevice)),
        action: () => {
          // console.log('CASE 3 – Trusted device flow (PIN validation)');
          if (pathname !== '/pin') navigate('/pin');
        },
      },
      // CASE 4 – Un-trusted device & no record → 2FA Security Question
      {
        condition:
          accessToken === undefined && isFalse(isTrustedDevice) && isFalse(haveTrustedDevice),
        action: () => {
          // console.log('CASE 4 – Un-trusted device & no record → 2FA Security Question');
          if (pathname !== '/2fa') navigate(`/2fa?method=${TWO_FA_METHOD.SECURITY_QUESTION}`);
        },
      },
      // CASE 5 – Un-trusted device but device record exists → 2FA Notification
      {
        condition:
          accessToken === undefined && isFalse(isTrustedDevice) && isTrue(haveTrustedDevice),
        action: () => {
          // console.log('CASE 5 – Un-trusted device but device record exists → 2FA Notification');
          if (pathname !== '/2fa') navigate(`/2fa?method=${TWO_FA_METHOD.NOTIFICATION}`);
        },
      },
      // CASE 6 – PIN needs to change to 6 digits specifically
      {
        condition:
          accessToken !== undefined &&
          isTrue(pinNeedChange) &&
          isFalse(isPin6Digit) &&
          isTrue(hasSetPin),
        action: () => {
          // console.log('CASE 6 – PIN needs to change to 6 digits specifically');
          // Stay on create/validate flow if user already there; otherwise force to renew-pin
          if (!['/create-pin', '/validate-pin', '/renew-pin'].includes(pathname)) {
            navigate('/renew-pin');
          }
        },
      },
      // CASE 7 - Have an access token should redirecting to home
      {
        condition: !!accessToken,
        action: () => {
          // console.log('CASE 7 - Have an access token should redirecting to home');
          if (pathname === '/loading') {
            navigate('/home');
          }
        },
      },
    ];

    const matchedRule = navigationRules.find(({ condition }) => condition);
    if (matchedRule) matchedRule.action();
  },
};
